import * as React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

interface LoadingScreenProps {
  label?: string;
}

export function LoadingScreen({
  label = "Loading Falcon...",
}: LoadingScreenProps): React.JSX.Element {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        gap: 2,
      }}
    >
      <CircularProgress aria-label="loading" />
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
}
